import React from "react";
import ContentContainer from "../../containers/ContentContainer";
import SubScribeCardsContainer from "../../cards/SubscribeCards/Container";

export interface PaywalledProps {
  excerpt: string;
}

const Paywalled = ({ excerpt }: PaywalledProps) => {
  return (
    <>
      <ContentContainer bgColor="bg-white">
        <div className={"flex flex-col gap-4"}>
          <div
            className={"bodycontent font-sans"}
            dangerouslySetInnerHTML={{ __html: excerpt }}
          ></div>
        </div>
      </ContentContainer>
      <SubScribeCardsContainer />
    </>
  );
};

export default Paywalled;
